export const ChartColorsEnum = Object.freeze({
  darkestBlue: "#0e2841",
  darkBlue: "#104862",
  smoke_90: "#364d6e",
  darkBlue_25: "#215f9a",
  smoke_80: "#4c6c9c",
  smoke_60: "#6f8db9",
  smoke_40: "#9db1cf",
  smoke_20: "#c3cfe1",
  smoke_10: "#dfe5ef",
});

export const CHART_COLORS = Object.freeze([
  ChartColorsEnum.darkestBlue,
  ChartColorsEnum.darkBlue,
  ChartColorsEnum.smoke_90,
  ChartColorsEnum.darkBlue_25,
  ChartColorsEnum.smoke_80,
  ChartColorsEnum.smoke_60,
  ChartColorsEnum.smoke_40,
  ChartColorsEnum.smoke_20,
  ChartColorsEnum.smoke_10,
]);
